import React from 'react';
import { Link } from 'react-router-dom';

const trendingProducts = [
  {
    id: 1,
    badge: 'BEST SELLER',
    brand: 'OAKLEY',
    title: 'Urban Maverick',
    price: '149.00',
    image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&auto=format'
  },
  {
    id: 2,
    badge: 'TRENDING',
    brand: 'RAYBAN',
    title: 'Vintage Scholar',
    price: '129.00',
    image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?w=800&auto=format'
  },
  {
    id: 3,
    badge: 'NEW ARRIVAL',
    brand: 'SILLOUETTE',
    title: 'Cat Eye Noir',
    price: '159.00',
    image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&auto=format'
  },
  {
    id: 4,
    badge: 'HOT',
    brand: 'TOMMY HILFIGER',
    title: 'Arctic Blue',
    price: '110.00',
    image: 'https://images.unsplash.com/photo-1614715838608-dd527c46231d?w=800&auto=format'
  }
];

export default function TrendingNow() {
  return (
    <section className="bg-white py-16 overflow-hidden">
      <div className="site-container">
        
        {/* Header Row */}
        <div data-aos="fade-up" className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <h2 className="section-heading mb-4 leading-tight">
              Trending Now
            </h2>
            <p className="section-copy font-medium">
              Our most popular designs this season, curated for those who value <br className="hidden lg:block" />
              both style and visual excellence.
            </p>
          </div>
          <div className="pb-2">
            <Link to="/shop" className="text-brand-blue font-bold text-[16px] border-b-[2px] border-brand-blue pb-1 hover:opacity-80 transition-all group flex items-center gap-2">
              View all products
            </Link>
          </div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {trendingProducts.map((product, index) => (
            <div key={product.id} data-aos="fade-up" data-aos-delay={index * 100} className="group cursor-pointer">
              {/* Product Image Card */}
              <div className="relative mb-5 aspect-square overflow-hidden rounded-[28px] shadow-sm transition-all duration-500 hover:shadow-xl sm:mb-6 sm:rounded-[34px]">
                {/* Badge */}
                <div className="absolute top-6 left-6 z-10">
                  <span className="rounded-xl bg-brand-red px-4 py-2 text-[10px] font-black tracking-wider text-white shadow-lg sm:text-[11px]">
                    {product.badge}
                  </span>
                </div>

                <div className="w-full h-full">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
              </div>

              {/* Product Info */}
              <div className="px-2">
                <p className="text-[10px] font-bold text-gray-400 tracking-[0.15em] uppercase mb-1.5">
                  {product.brand}
                </p>
                <h3 className="mb-1 text-[18px] font-black leading-tight text-brand-dark transition-colors group-hover:text-brand-blue sm:text-[20px]">
                  {product.title}
                </h3>
                <p className="text-[18px] font-black text-brand-blue">
                  KSH. {product.price}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
